// Copyright (c) 2020 Deere & Company

import Favorite from '@deere/cps-it.warranty-model-factory/lib/favorite';
import t from 'tcomb';

const Favorites = t.list(Favorite, 'Favorites');

export const getDefaultState = () =>
    new Favorites([]);

export default Favorites;



// WEBPACK FOOTER //
// ./src/shared/components/favorites/state/favorites.js